export default "__VITE_ASSET__CMd6z1Ic__"